import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IacctRange } from '../../../shared/models/models';

@Component({
  selector: 'app-iact-list-index',
  templateUrl: './iact-list-index.component.html',
})
export class IactListIndexComponent implements OnInit {
  iacctRanges: IacctRange[] = null;
  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
    this.updateIacctRanges();
  }

  updateIacctRanges() {
    this.route.data.subscribe(({ iacctRanges }: { iacctRanges: IacctRange[]}) => {
      this.iacctRanges = iacctRanges;
    });
  }
}
